import { computed } from 'vue'

import { useExperiments } from '@backmarket/nuxt-module-experiments/useExperiments'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { useTracking } from '@backmarket/nuxt-module-tracking/useTracking'

import { useFetchReviewsSummary } from '~/scopes/product-core/composables/useFetch/useFetchReviewsSummary/useFetchReviewsSummary'

import translations from '../StickyBarRatingChip.translations'

export function useStickyBarRating() {
  const i18n = useI18n()
  const experiments = useExperiments()
  const { trackClick } = useTracking()
  const { data: reviewsSummary } = useFetchReviewsSummary()

  const shouldDisplayRating = computed(
    () =>
      experiments['experiment.reviewsRatingHeader'] ===
        'withReviewsRatingHeader' && (reviewsSummary.value?.count ?? 0) > 0,
  )

  const displayedRating = computed(() => reviewsSummary.value?.averageRate ?? 0)

  const ratingAriaLabel = computed(() => {
    const averageRate = reviewsSummary.value?.averageRate ?? 0

    return i18n(translations.ratingAriaLabel, {
      rating: i18n.number(averageRate, { maximumFractionDigits: 1 }),
    })
  })

  function onRatingClick() {
    trackClick({
      pageType: 'product',
      zone: 'pp_sticky_top_bar_rating',
      rating: reviewsSummary.value?.averageRate ?? 0,
    })
  }

  return {
    shouldDisplayRating,
    displayedRating,
    ratingAriaLabel,
    onRatingClick,
  }
}
